import { useAuthentication } from '@app/src/context/AuthenticationContext'
import { getProviderTypeFromSolution } from '@app/src/utils/solution'
import { capitalize } from '@app/src/utils/helpers'
import { Solutions } from '@app/src/wf-constants'

export default (): string => {
  const { scope } = useAuthentication()
  return getProviderTypeFromSolution(capitalize(scope.solution) as keyof typeof Solutions)
}
